import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import { ACTIVITIES_MAIN_DATA } from './activities.data';
import { UrlDetectorPipe } from '../../../Services/urlDetector.pipe';

@AutoUnsubscribe()
@Component({
  selector: 'app-activities',
  standalone: true,
  imports: [RouterOutlet, CommonModule, UrlDetectorPipe],
  providers: [SchoolApiService],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivitiesComponent extends BaseComponent {
  ACTIVITIES_MAIN_DATA = ACTIVITIES_MAIN_DATA;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
